import { BOTTOMITEMS, CUSTOMITEMS, IMAGE, METRO, MOVIE, TEXT, TITLE } from '../../../constants/itemTypes'
import ListItemMovieContainer from '../../DragAndDropItems/cont/ListItemMovieContainer'
import ListItemImageContainer from '../../DragAndDropItems/cont/ListItemImageContainer'
import ListItemTextContainer from '../../DragAndDropItems/cont/ListItemTextContainer'

const FlyerDragSwitch = ({
    itemId,
    itemType,
    itemData,
    basicUrl,
    isSelected=false,
    canEdit,
    canDelete=false,
    deleteItem=false
}) => {
    const basicPathNameEdit =  `${basicUrl}/${itemType}/`

    return (
        MOVIE === itemType ? (
            <ListItemMovieContainer
                itemType={itemType}
                itemData={itemData}
                isSelected={isSelected}
                pathnameEdit={canEdit ? basicPathNameEdit + itemData.id : false}
                onDelete={canDelete && deleteItem ? () => deleteItem(itemType, itemId) : false}
            />
        ) : IMAGE === itemType || METRO === itemType ? (
            <ListItemImageContainer
                imgKey={IMAGE === itemType ? 'payload' : 'image'}
                itemType={itemType}
                itemData={itemData}
                isSelected={isSelected}
                pathnameEdit={canEdit ? basicPathNameEdit + itemData.id : false}
                onDelete={canDelete && deleteItem ? () => deleteItem(itemType, itemId) : false}
            />
        ) : TEXT === itemType || TITLE === itemType ?(
            <ListItemTextContainer
                textKey='payload'
                itemType={itemType}
                itemData={itemData}
                isSelected={isSelected}
                pathnameEdit={canEdit ? basicPathNameEdit + itemData.id : false}
                onDelete={canDelete && deleteItem ? () => deleteItem(itemType, itemId) : false}
            />
        ) : CUSTOMITEMS === itemType ?(
            <ListItemTextContainer
                textKey='name'
                itemType={itemType}
                itemData={itemData}
                isSelected={isSelected}
                pathnameEdit={canEdit ? basicPathNameEdit + itemData.id : false}
                onDelete={canDelete && deleteItem ? () => deleteItem(itemType, itemId) : false}
            />
         ) : ('')
    )
}

export default FlyerDragSwitch